import React, {Component} from "react";
import applogic from "../applogic.js";

class BackButton extends Component {
    render() {
        return (
            <a className="back-button" onClick={applogic.goBack}>
                <svg className="back-button" width="38px" height="38px" viewBox="0 0 100 100" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon points="60 18 0 50 60 82" stroke="#0275d8" fill="rgba(255,255,255,.85)"
                             strokeWidth="6"></polygon>
                </svg>
            </a>
        );
    }
}
export default BackButton;




// WEBPACK FOOTER //
// ./src/componentsHeader/BackButton.js